var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"o-shape",class:("-" + _vm.shapeName)},[_c('icon',{attrs:{"icon":_vm.shapeName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }